import React from 'react';
/* eslint-disable */
export const IconLogin = () => (
    <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2784_12392)">
    <path d="M80 46C80 64.7777 64.7777 80 46 80C27.2223 80 12 64.7777 12 46C12 27.2223 27.2223 12 46 12C64.7777 12 80 27.2223 80 46Z" fill="#E3F4FF"/>
    <path d="M46 52C54.2843 52 61 45.2843 61 37C61 28.7157 54.2843 22 46 22C37.7157 22 31 28.7157 31 37C31 45.2843 37.7157 52 46 52Z" fill="url(#paint0_linear_2784_12392)"/>
    <path d="M46 80C58.0145 80 68.5735 73.7682 74.6211 64.3607C66.0087 60.9305 56.2878 59 46 59C35.7122 59 25.9913 60.9305 17.3789 64.3607C23.4264 73.7682 33.9855 80 46 80Z" fill="url(#paint1_linear_2784_12392)"/>
    <path d="M76 57.5C76 56.1193 74.8807 55 73.5 55C72.1193 55 71 56.1193 71 57.5V65H63.5C62.1193 65 61 66.1193 61 67.5C61 68.8807 62.1193 70 63.5 70H71V77.5C71 78.8807 72.1193 80 73.5 80C74.8807 80 76 78.8807 76 77.5V70H83.5C84.8807 70 86 68.8807 86 67.5C86 66.1193 84.8807 65 83.5 65H76V57.5Z" fill="url(#paint2_linear_2784_12392)"/>
    </g>
    <defs>
    <linearGradient id="paint0_linear_2784_12392" x1="46" y1="80" x2="46" y2="22" gradientUnits="userSpaceOnUse">
    <stop stopColor="#C1E4FA"/>
    <stop offset="1" stopColor="#9FD0EE"/>
    </linearGradient>
    <linearGradient id="paint1_linear_2784_12392" x1="46" y1="80" x2="46" y2="22" gradientUnits="userSpaceOnUse">
    <stop stopColor="#C1E4FA"/>
    <stop offset="1" stopColor="#9FD0EE"/>
    </linearGradient>
    <linearGradient id="paint2_linear_2784_12392" x1="62.5708" y1="80" x2="62.3826" y2="54.9991" gradientUnits="userSpaceOnUse">
    <stop stopColor="#7ECCF8"/>
    <stop offset="1" stopColor="#0087CD"/>
    </linearGradient>
    <clipPath id="clip0_2784_12392">
    <rect width="92" height="92" fill="white"/>
    </clipPath>
    </defs>
    </svg>
);
